import Box from '@mui/material/Box';
import React from 'react';

const airshipStyle = {
  position: 'relative',
  width: '604px',
  height: '350px',
  overflow: 'visible',
};

const svgStyle = {
  position: 'absolute',
  top: '80px',
  left: '0',
  animation: 'fly 5s infinite linear',
};

const cloudContainerStyle = {
  position: 'absolute',
  top: '0',
  left: '0',
  width: '100%',
  height: '100%',
  overflow: 'visible',
};

const cloudStyle = {
  position: 'absolute',
  animation: 'move-clouds 20s linear infinite',
  opacity: 0.7,
};

const keyframes = `
    @keyframes fly {
      0% {
        transform: translateY(0);
      }
      50% {
        transform: translateY(-20px);
      }
      100% {
        transform: translateY(0);
      }
    }

    @keyframes move-clouds {
      0% {
        transform: translateX(0px);
      }
      100% {
        transform: translateX(-1200px);
      }
    }
  `;

export const AirshipAnimationWithClouds: React.FC = React.memo(() => {
  const generateClouds = React.useCallback(() => {
    const clouds = [];
    for (let i = 0; i < 3; i++) {
      const size = `${50 + Math.random() * 100}px`;
      const top = `${
        10 +
        Math.ceil(Math.random()) * (Math.round(Math.random()) ? 1 : -1) * -30
      }%`;
      const right = `${Math.random() * 1200}px`;
      clouds.push(
        <Box
          key={i}
          sx={{
            ...cloudStyle,
            width: size,
            height: size,
            top: top,
            left: right,
          }}
        >
          <svg
            height="200px"
            width="200px"
            viewBox="0 0 371.62 371.62"
            fill="#AEDAF6"
            overflow={'visible'}
          >
            <g>
              <path d="M62.513,153.087c-0.009-0.525-0.02-1.049-0.02-1.575c0-50.155,40.659-90.814,90.814-90.814 c43.222,0,79.388,30.196,88.562,70.643c8.555-4.789,18.409-7.531,28.91-7.531c32.766,0,59.328,26.562,59.328,59.328 c0,1.339-0.06,2.664-0.148,3.981c24.325,9.03,41.661,32.444,41.661,59.911c0,35.286-28.605,63.892-63.892,63.892H79.865 C35.757,310.921,0,275.164,0,231.056C0,192.907,26.749,161.011,62.513,153.087z" />
            </g>
          </svg>
        </Box>
      );
    }
    return clouds;
  }, []);

  return (
    <Box sx={airshipStyle}>
      <style>{keyframes}</style>
      <Box sx={cloudContainerStyle}>{generateClouds()}</Box>
      <Box
        component="svg"
        viewBox="0 0 604 186"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        sx={{ width: '604', height: '186', ...svgStyle }}
      >
        <path
          d="M454.574 12.8314C413.318 6.9265 368.677 6.37535 307.974 6.37535C251.051 6.37535 192.002 14.721 146.573 23.3028C142.007 24.1688 127.284 2.43873 127.284 2.43873C125.867 1.02155 124.056 0.312988 122.087 0.312988L72.1712 5.7455C68.0771 5.7455 64.7704 9.05225 64.7704 13.1463V44.1669C24.3807 58.2599 0.288635 69.3612 0.288635 83.533C0.288635 97.7048 24.3807 107.153 64.7704 120.458V150.377C64.7704 154.471 68.0771 157.778 72.1712 157.778L122.087 163.21C124.056 163.21 125.945 162.423 127.284 161.084C127.284 161.084 142.007 139.354 146.573 140.22C184.365 147.385 227.431 156.675 273.647 158.486C277.662 158.644 293.881 183.051 293.881 183.051C295.298 184.468 297.109 185.176 299.078 185.176H369.858C371.826 185.176 373.716 184.389 375.054 183.051C375.054 183.051 391.273 157.778 395.21 157.62C416.861 156.754 436.623 155.416 454.574 153.054C562.28 139.118 604.008 101.563 604.008 83.533C604.008 65.5033 559.209 28.0267 454.574 12.9101V12.8314Z"
          fill="#E83F34"
        />
        <path
          d="M29.8131 86.6819C28.7896 86.6031 28.5534 88.0991 29.4194 88.5714C41.6229 95.8148 99.8061 123.371 182.869 135.102C244.988 143.841 302.227 147.699 382.455 143.605C462.683 139.511 508.584 130.457 547.793 109.121C567.082 98.6492 574.64 90.461 578.813 86.2095C579.443 85.5796 579.049 84.3199 578.183 84.4774C512.914 92.5868 456.07 99.279 302.069 99.9089C150.51 100.539 103.585 92.6655 29.8131 86.6819Z"
          fill="#AF2C2C"
        />
      </Box>
    </Box>
  );
});
